/**
*
* HomePage
*
*/

import React from 'react';
import { Helmet } from 'react-helmet';

import helpContext from 'constants/helpContext';
import Sidebar from 'Workspace/components/WorkspaceSidebar';

import WorkspaceHeader from 'Workspace/components/WorkspaceHeader';
import HomeNavigation from 'Workspace/components/HomeNavigation';
import HelpMenu from 'Workspace/components/WorkspaceHelpMenu';
import {
  PageWrapper,
  PageContent,
} from 'components/PageStyles';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import {
  HomepageHeader,
  HomepageSubheading,
  PageViewportWithBg,
} from './styles';
import messages from './messages';
import Welcome from './Welcome';
import BetaMessage from './BetaMessage';
import gtmService from 'utils/gtm/gtmService';
import { GTM_EVENT_TYPES } from 'utils/gtm/constants';

class HomePage extends React.Component {

  componentDidMount() {
    gtmService.gtmTrackEvent({ eventType: GTM_EVENT_TYPES.PAGEVIEW, payload: { pageName: 'Home Page' } });
  }

  render() {
    return (
      <PageWrapper>
        <Helmet>
          <title>{intl.formatMessage(messages.pageTitle)}</title>
          <meta
            name="description"
            content={intl.formatMessage(messages.pageDescription)}
          />
        </Helmet>
        <Sidebar navigation={<HomeNavigation showHeader />} ></Sidebar>
        <PageViewportWithBg>
          <WorkspaceHeader title={intl.formatMessage(messages.home)}/>
          <PageContent>
            <HomepageHeader>
              <HomepageSubheading>
                Your Workspace
              </HomepageSubheading>
              <Welcome/>
            </HomepageHeader>
            <BetaMessage/>
          </PageContent>
        </PageViewportWithBg>
        <HelpMenu helpContext={helpContext.HOME}/>
      </PageWrapper>
    );
  }
}

export default HomePage;
